(() => {
  const root = window.Shopify?.routes?.root || '/';

  const qs = (sel, el = document) => el.querySelector(sel);
  const qsa = (sel, el = document) => Array.from(el.querySelectorAll(sel));

  function openCartDrawer() {
    const drawer = qs('#cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else qs('#cart-drawer [on\\:click]') || document.dispatchEvent(new CustomEvent('cart:open'));
  }

  function updateCartBubble(count) {
    qsa('[data-cart-count], .cart-bubble, cart-icon .cart-bubble__count').forEach((el) => {
      el.textContent = String(count);
    });
    qsa('cart-icon').forEach((el) => {
      el.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch(`${root}?section_id=cart-drawer-section`);
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('#shopify-section-cart-drawer-section') || doc.body;
      const current = qs('#shopify-section-cart-drawer-section');
      if (current && next) current.replaceWith(next);
    } catch (e) {
      /* drawer refresh is best-effort */
    }
  }

  async function addToCart(id, quantity = 1) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: Number(quantity) || 1 }),
    });
    const data = await res.json();
    if (!res.ok) {
      const msg = data?.description || data?.message || 'Could not add to cart';
      throw new Error(msg);
    }
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());
    updateCartBubble(cart.item_count);
    await refreshCartDrawer();
    openCartDrawer();
    return cart;
  }

  window.TekvoTheme = { addToCart, openCartDrawer, refreshCartDrawer };

  document.addEventListener('click', (event) => {
    const searchBtn = event.target.closest('[on\\:click="#search-modal/showDialog"], [data-tekvo-search]');
    if (!searchBtn) return;
    const modal = document.getElementById('search-modal');
    if (modal && typeof modal.showDialog === 'function') {
      event.preventDefault();
      modal.showDialog();
    }
  });

  /* Announcement dismiss */
  qsa('[data-tekvo-announce]').forEach((bar) => {
    const key = bar.getAttribute('data-dismiss-key');
    if (key && sessionStorage.getItem(key) === '1') {
      bar.hidden = true;
      return;
    }
    qs('[data-tekvo-announce-dismiss]', bar)?.addEventListener('click', () => {
      bar.hidden = true;
      if (key) sessionStorage.setItem(key, '1');
    });
  });

  /* Header mobile drawer */
  const header = qs('[data-tekvo-header]');
  if (header) {
    const toggle = qs('[data-tekvo-nav-toggle]', header);
    const drawer = qs('[data-tekvo-nav-drawer]', header);
    const closeBtn = qs('[data-tekvo-nav-close]', header);
    const setOpen = (open) => {
      header.classList.toggle('is-nav-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
      if (drawer) drawer.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    };
    toggle?.addEventListener('click', () => setOpen(!header.classList.contains('is-nav-open')));
    closeBtn?.addEventListener('click', () => setOpen(false));
    qs('[data-tekvo-nav-backdrop]', header)?.addEventListener('click', () => setOpen(false));
    qsa('[data-tekvo-accordion]', header).forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = btn.nextElementSibling;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.hidden = expanded;
      });
    });
  }

  /* Product sliders */
  qsa('[data-tekvo-slider]').forEach((rootEl) => {
    const track = qs('[data-tekvo-slider-track]', rootEl);
    if (!track) return;
    const step = () => Math.max(track.clientWidth * 0.8, 240);
    qs('[data-tekvo-slider-prev]', rootEl)?.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    qs('[data-tekvo-slider-next]', rootEl)?.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });

  /* Quick add (single variant) */
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-tekvo-quick-add]');
    if (!btn) return;
    event.preventDefault();
    const id = btn.getAttribute('data-variant-id');
    if (!id) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await addToCart(id, 1);
      btn.textContent = 'Added';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1200);
    } catch (err) {
      btn.textContent = original;
      btn.disabled = false;
      alert(err.message);
    }
  });

  /* Quick shop modal */
  const overlay = qs('[data-tekvo-qs]');
  function closeQs() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function openQs(card) {
    if (!overlay || !card) return;
    const data = JSON.parse(card.getAttribute('data-tekvo-product') || '{}');
    qs('[data-tekvo-qs-title]', overlay).textContent = data.title || '';
    qs('[data-tekvo-qs-price]', overlay).textContent = data.price || '';
    const img = qs('[data-tekvo-qs-image]', overlay);
    if (img) {
      img.src = data.image || '';
      img.alt = data.title || '';
      img.hidden = !data.image;
    }
    const optionsHost = qs('[data-tekvo-qs-options]', overlay);
    optionsHost.innerHTML = '';
    (data.options || []).forEach((opt, index) => {
      if (opt.name === 'Title' && opt.values?.length === 1 && opt.values[0] === 'Default Title') return;
      const label = document.createElement('label');
      label.className = 'tekvo-qs__field';
      label.innerHTML = `<span class="tekvo-qs__label">${opt.name}</span>`;
      const select = document.createElement('select');
      select.className = 'tekvo-qs__select';
      select.dataset.optionIndex = String(index);
      opt.values.forEach((value) => {
        const o = document.createElement('option');
        o.value = value;
        o.textContent = value;
        select.appendChild(o);
      });
      label.appendChild(select);
      optionsHost.appendChild(label);
    });
    overlay.dataset.variants = JSON.stringify(data.variants || []);
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    syncQsVariant();
  }

  function selectedOptions() {
    return qsa('[data-tekvo-qs-options] select', overlay).map((s) => s.value);
  }
  function syncQsVariant() {
    const variants = JSON.parse(overlay?.dataset.variants || '[]');
    const selected = selectedOptions();
    const match = variants.find((v) => selected.every((val, i) => v.options[i] === val)) || variants[0];
    const submit = qs('[data-tekvo-qs-submit]', overlay);
    const price = qs('[data-tekvo-qs-price]', overlay);
    const err = qs('[data-tekvo-qs-error]', overlay);
    if (err) err.textContent = '';
    if (!match) {
      if (submit) submit.disabled = true;
      return;
    }
    if (price && match.price) price.textContent = match.price;
    if (submit) {
      submit.dataset.variantId = match.id;
      submit.disabled = !match.available;
      submit.textContent = match.available ? 'Add to cart' : 'Sold out';
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tekvo-quick-shop]');
    if (trigger) {
      event.preventDefault();
      openQs(trigger.closest('[data-tekvo-product]'));
    }
    if (event.target.closest('[data-tekvo-qs-close], [data-tekvo-qs-backdrop]')) {
      closeQs();
    }
  });
  overlay?.addEventListener('change', (event) => {
    if (event.target.matches('select')) syncQsVariant();
  });
  qs('[data-tekvo-qs-submit]', overlay)?.addEventListener('click', async (event) => {
    const btn = event.currentTarget;
    const id = btn.dataset.variantId;
    const err = qs('[data-tekvo-qs-error]', overlay);
    if (!id) return;
    btn.disabled = true;
    try {
      await addToCart(id, 1);
      closeQs();
    } catch (e) {
      if (err) err.textContent = e.message;
    } finally {
      btn.disabled = false;
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay?.classList.contains('is-open')) closeQs();
  });

  /* PDP AJAX add */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-tekvo-product-form]');
    if (!form) return;
    event.preventDefault();
    const id = form.querySelector('[name="id"]')?.value;
    const qty = form.querySelector('[name="quantity"]')?.value || 1;
    const btn = form.querySelector('[type="submit"]');
    const original = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      await addToCart(id, qty);
      if (btn) btn.textContent = 'Added';
    } catch (e) {
      alert(e.message);
      if (btn) btn.textContent = original;
    } finally {
      if (btn) setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 900);
    }
  });
})();
